<template>
    <a-modal
            :width="'60%'"
            v-model="entityDetail"
            :title="$t('supervise.entityInfo')"
            :maskClosable="maskClosable">

        <template slot="footer">
            <a-button type="primary" @click="handleOk">
                {{$t('global.OK')}}
            </a-button>
        </template>

        <div style="padding:20px;">
            <a-card>
                <div style="font-weight:500;font-size:16px">{{$t('supervise.entityInfo')}}</div>
                <a-row :gutter="24" style="margin-left: -16px; margin-right: -16px;margin-top:25px" v-if="entityInfos">
                    <a-col span="8">
                        <a-row>
                            <a-col style="padding-left:16px;padding-right:16px;" v-for="item in titles" :key="item.name" :xs="{span:24}" :sm="{span:24}" :lg="{span:24}">
                                <div v-if="item.inputType === 'image'"            class="antd-pro-components-description-list-index-detail">
                                    <img v-if="entityInfos[item.name]" style="width:80px" :src="entityInfos[item.name]">
                                    <div class="empty" v-else>
                                        {{$t('supervise.noPic')}}
                                    </div>
                                </div>
                            </a-col>
                        </a-row>
                    </a-col>
                    <a-col span="16">
                        <a-row>
                            <a-col style="padding-left:16px;padding-right:16px" v-for="item in titles" :key="item.name" :xs="{span:12}" :sm="{span:12}" :lg="{span:12}">
                                <div v-if="item.inputType !== 'image'" class="antd-pro-components-description-list-index-term" style="white-space: nowrap">{{$t(`columnCheck.${item.name}`)}}</div>
                                <template v-if="entityInfos[item.name] && item.inputType !== 'image'">
                                    <div v-if="item.inputType == 'date'" class="antd-pro-components-description-list-index-detail">{{timeFormat(entityInfos[item.name]) || $t('global.none')}}</div>
                                    <div v-else class="antd-pro-components-description-list-index-detail">{{entityInfos[item.name] || $t('global.none')}}</div>
                                </template>
                            </a-col>
                        </a-row>
                    </a-col>
                    
                </a-row>
                <a-divider />

                <div style="font-weight:500;font-size:16px">{{$t('home.deviceInfo')}}</div>

                <a-row v-if="devices && devices.length > 0" :gutter="24" style="margin-left: -16px; margin-right: -16px;margin-top:25px">
                    <template v-for="(item, index) in devices">
                        <a-col :key="index+1" style="padding-left:16px;padding-right:16px" :xs="{span:24}" :sm="{span:12}" :lg="{span:8}">
                            <div class="antd-pro-components-description-list-index-term" style="white-space: nowrap">{{$t('columnCheck.manufacturer')}}</div>
                            <div class="antd-pro-components-description-list-index-detail">{{item.oui}}</div>
                        </a-col>
                        <a-col :key="index+2" style="padding-left:16px;padding-right:16px" :xs="{span:24}" :sm="{span:12}" :lg="{span:8}">
                            <div class="antd-pro-components-description-list-index-term" style="white-space: nowrap">{{$t('columnCheck.serialNumber')}}</div>
                            <div class="antd-pro-components-description-list-index-detail">{{item.sn}}</div>
                        </a-col>
                        <a-col :key="index+3" style="padding-left:16px;padding-right:16px" :xs="{span:24}" :sm="{span:12}" :lg="{span:8}">
                            <div class="antd-pro-components-description-list-index-term" style="white-space: nowrap">IMSI</div>
                            <div class="antd-pro-components-description-list-index-detail">{{item.deviceExtension.imei ? item.deviceExtension.imei : '---'}}</div>
                        </a-col>
                        <a-col :key="index+4" style="padding-left:16px;padding-right:16px" :xs="{span:24}" :sm="{span:12}" :lg="{span:8}">
                            <div class="antd-pro-components-description-list-index-term" style="white-space: nowrap">ICCID</div>
                            <div class="antd-pro-components-description-list-index-detail">{{item.deviceExtension.iccid ? item.deviceExtension.iccid : '---'}}</div>
                        </a-col>
                        <a-col :key="index+5" style="padding-left:16px;padding-right:16px" :xs="{span:24}" :sm="{span:12}" :lg="{span:8}">
                            <div class="antd-pro-components-description-list-index-term" style="white-space: nowrap">{{$t('columnCheck.power')}}</div>
                            <div class="antd-pro-components-description-list-index-detail">{{item.power ? item.power : $t('global.none')}}</div>
                        </a-col>
                    </template>
                </a-row>

                <div v-else style="margin-top:25px">{{$t('global.none')}}</div>
            </a-card>
        </div>
    </a-modal>
</template>

<script>
    import config from '@/config'
    import moment from 'moment'
    export default {
        name: 'ZEntityDetail',
        props:['titles'],
        data() {
            return {
                entityDetail: false,
                maskClosable: false,
                entityInfos: null,
                devices: []
            }
        },
        methods: {
            timeFormat(timestamp) {
              if (timestamp === -1) {
                return this.$t('global.none')
              } else {
                return moment(timestamp * 1000).format('YYYY-MM-DD')
              }
            },
            handleOk() {
                this.entityDetail = false
            },
            showModel(entityId){
                this.$http.get(config.api.entity_detail_url + "/" + entityId).then((response) => {
                    if(response.code == 0){
                        this.entityDetail = true
                        this.entityInfos = response.result.entity.attrs
                        // console.log(this.entityInfos)
                        this.devices = response.result.devices
                    }
                }).catch((err) => {
                    console.log(err)
                })
            }
        }
    }
</script>

<style scoped>
    .antd-pro-components-description-list-index-term {
        display: table-cell;
        padding-bottom: 16px;
        color: rgba(0,0,0,.85);
        line-height: 20px;
        white-space: nowrap;
    }
    .antd-pro-components-description-list-index-detail {
        display: table-cell;
        width: 100%;
        padding-bottom: 16px;
        color: rgba(0,0,0,.65);
        line-height: 20px;
    }
    .antd-pro-components-description-list-index-term::after {
        position: relative;
        top: -.5px;
        margin: 0 8px 0 2px;
        content: ":";
    }
    .empty {
        width: 80px;
        height: 112px;
        border: 1px dashed #aaa;
        line-height: 112px;
        text-align: center;
    }
</style>